const init = () => {
    var $component = $('.c-banner-author');
    if (!$component.length) return;
    var $magnify = $('.c-banner-author__magnify');
    $magnify.click(function(e) {
        e.preventDefault();
        var lightbox = penguinModal($(this).attr('href'));
    });
}

export default init;